import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/cooking/cooking-dynamic/page',
    method: 'get',
    params
  })
}

export function addObj(data) {
  return request({
    url: '/cooking/cooking-dynamic/add',
    method: 'post',
    data
  })
}
export function putObj(data) {
  return request({
    url: '/cooking/cooking-dynamic/edit',
    method: 'post',
    data
  })
}
export function delObj(data) {
  return request({
    url: '/cooking/cooking-dynamic/delete',
    method: 'post',
    data
  })
}
export function getObj(id) {
  return request({
    url: '/cooking/cooking-dynamic/detail',
    method: 'get',
    params: { id }
  })
}
export function putTop(data) {
  return request({
    url: '/cooking/cooking-dynamic/tj',
    method: 'post',
    data
  })
}
